// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.switch-checkbox {
  position: relative;
  display: inline-block;
  width: 50px;
  height: 30px;
}
.switch-checkbox input {
  opacity: 0;
  width: 0;
  height: 0;
}
.switch-checkbox input:checked + .slider {
  background-color: #4cd964;
}
.switch-checkbox input:checked + .slider:before {
  transform: translateX(20px);
}
.switch-checkbox .slider {
  position: absolute;
  cursor: pointer;
  background-color: #ccc;
  border-radius: 34px;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  transition: background-color 0.2s;
}
.switch-checkbox .slider:before {
  position: absolute;
  content: "";
  height: 26px;
  width: 26px;
  left: 2px;
  bottom: 2px;
  background: #fff;
  border-radius: 50%;
  transition: transform 0.2s;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.3);
}`, "",{"version":3,"sources":["webpack://./src/_core/components/common/UI/SwitchCheckBox.scss"],"names":[],"mappings":"AAAA;EACI,kBAAA;EACA,qBAAA;EACA,WAAA;EACA,YAAA;AACJ;AACI;EACI,UAAA;EACA,QAAA;EACA,SAAA;AACR;AACQ;EACI,yBAAA;AACZ;AAEQ;EACI,2BAAA;AAAZ;AAII;EACI,kBAAA;EACA,eAAA;EACA,sBAAA;EACA,mBAAA;EACA,MAAA;EACA,OAAA;EACA,QAAA;EACA,SAAA;EACA,iCAAA;AAFR;AAIQ;EACI,kBAAA;EACA,WAAA;EACA,YAAA;EACA,WAAA;EACA,SAAA;EACA,WAAA;EACA,gBAAA;EACA,kBAAA;EACA,0BAAA;EACA,wCAAA;AAFZ","sourcesContent":[".switch-checkbox {\r\n    position: relative;\r\n    display: inline-block;\r\n    width: 50px;\r\n    height: 30px;\r\n\r\n    input {\r\n        opacity: 0;\r\n        width: 0;\r\n        height: 0;\r\n\r\n        &:checked+.slider {\r\n            background-color: #4cd964;\r\n        }\r\n        \r\n        &:checked+.slider:before {\r\n            transform: translateX(20px);\r\n        }\r\n    }\r\n    \r\n    .slider {\r\n        position: absolute;\r\n        cursor: pointer;\r\n        background-color: #ccc;\r\n        border-radius: 34px;\r\n        top: 0;\r\n        left: 0;\r\n        right: 0;\r\n        bottom: 0;\r\n        transition: background-color 0.2s;\r\n\r\n        &:before {\r\n            position: absolute;\r\n            content: \"\";\r\n            height: 26px;\r\n            width: 26px;\r\n            left: 2px;\r\n            bottom: 2px;\r\n            background: #fff;\r\n            border-radius: 50%;\r\n            transition: transform 0.2s;\r\n            box-shadow: 0 1px 3px rgba(0, 0, 0, 0.3);\r\n        }\r\n    }\r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
